import { combineReducers, ReducersMapObject } from "redux";
import { annotationReducer } from "./annotationReducer";
import { annotationsReducer } from "./annotationsReducer";
import { ImageAnnotationsState } from "./dtos";
import { entitiesReducer } from "./entities";
import { imageReducer } from "./imageReducer";
import { messageEditorInfoReducer } from "./messageEditorInfoReducer";
import { popupReducer } from "./popupReducer";

export const imageAnnotationsReducer = () => {
    const reducersMapObj: ReducersMapObject<ImageAnnotationsState> = {
        entities: entitiesReducer,
        annotations: annotationsReducer,
        annotation: annotationReducer,
        image: imageReducer,
        popup: popupReducer,
        messageEditorInfo: messageEditorInfoReducer,
    };

    return combineReducers<ImageAnnotationsState>(reducersMapObj);
};
